import { render, staticRenderFns } from "./application-notification-area.vue?vue&type=template&id=2cd79cab"
import script from "./application-notification-area.vue?vue&type=script&lang=js"
export * from "./application-notification-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports